import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Button, Paper } from "@material-ui/core";
import ResponsiveTable from "../../table/ResponsiveTable";
import VenueRequestModal from "./VenueRequestModal";
import TableRowProfile from "../../util/TableRowProfile";
import { ProfileType } from "../../../types/enum";
import image from "../../../helper/image";

@inject("agentVenueStore", "templateStore", "profileStore")
@observer
class IncomingRequestsTable extends Component {
    state = {
        venueRequestModalState: false,
        request: undefined
    };

    columns = [
        { key: "venue", label: "Venue", width: "35%" },
        { key: "bookingDay", label: "Requested Booking Days", width: "30%" },
        { key: "status", label: "Status", width: "15%" },
        { key: "action", label: "", width: "20%" }
    ];

    safeParseJSON = (str) => {
        if (!str) return {};
        try {
            return JSON.parse(str);
        } catch (e) {
            return {};
        }
    };

    mapBookingDay = data => {
        var bookingDay = "";
        if (data) {
            if (data.monday) bookingDay += "Mon, ";
            if (data.tuesday) bookingDay += "Tue, ";
            if (data.wednesday) bookingDay += "Wed, ";
            if (data.thursday) bookingDay += "Thu, ";
            if (data.friday) bookingDay += "Fri, ";
            if (data.saturday) bookingDay += "Sat, ";
            if (data.sunday) bookingDay += "Sun, ";
        }
        return bookingDay.substr(0, bookingDay.length - 2);
    };

    mapRowData = () => {
        const rows = [];
        const { pendingAgentVenues } = this.props.agentVenueStore;

        if (!pendingAgentVenues || pendingAgentVenues.length === 0) {
            return rows;
        }

        pendingAgentVenues
            .filter(data => data && data.primaryProfile?.type !== ProfileType.Agent.ordinal)
            .forEach(data => {
                if (!data || !data.primaryProfile) return;
                
                var row = {};
                var venue = data.primaryProfile?.type === ProfileType.Venue.ordinal 
                    ? data.primaryProfile 
                    : data.secondaryProfile;

                row.id = "p" + data.id;
                row.data = data;
                row.style = { backgroundColor: "#fff3e0" };

                var jsonBookingDay = this.safeParseJSON(data.rules);
                row.bookingDay = this.mapBookingDay(jsonBookingDay);
                row.venue = (
                    <TableRowProfile 
                        profileId={venue?.id} 
                        name={venue?.fullName} 
                        avatarUrl={image.getProfileImage(venue)} 
                    />
                );
                row.status = <span style={{ color: "#ef6c00", fontWeight: 500 }}>Pending Review</span>;
                row.action = (
                    <Button color="primary" size="small" onClick={() => this.openVenueRequest(data)}>
                        View Request
                    </Button>
                );
                rows.push(row);
            });

        return rows;
    };

    openVenueRequest = request => {
        this.setState({
            venueRequestModalState: true,
            request: request
        });
    };

    closeVenueRequest = () => {
        this.setState({
            venueRequestModalState: false,
            request: undefined
        });
    };

    render() {
        const rows = this.mapRowData();

        return (
            <Fragment>
                <Paper style={{ padding: 24, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                    {rows.length > 0 ? (
                        <ResponsiveTable 
                            columns={this.columns} 
                            rows={rows} 
                            showToolbar={true}
                            title="Incoming Requests"
                        />
                    ) : (
                        <div style={{ textAlign: "center", padding: 60, color: "#888" }}>
                            <div style={{ fontSize: 48, marginBottom: 16 }}>📥</div>
                            <div style={{ fontSize: 16, marginBottom: 8 }}>No incoming requests</div>
                            <div style={{ fontSize: 14 }}>
                                When venues request you to manage their bookings, they will appear here.
                            </div>
                        </div>
                    )}
                </Paper>

                <VenueRequestModal 
                    open={this.state.venueRequestModalState} 
                    onClose={this.closeVenueRequest} 
                    request={this.state.request} 
                />
            </Fragment>
        );
    }
}

export default IncomingRequestsTable;
